@let apiResponse = data();
@if (apiResponse) {
  <p-table
    [metaKeySelection]="true"
    [value]="apiResponse.data"
    [loading]="dokService.datasource.isLoading()"
    [showGridlines]="true"
    [scrollable]="true"
    scrollHeight="flex"
    stripedRows
    [(first)]="dokService.firstRecordToShow"
    class="p-datatable-sm lp-table"
    selectionMode="single"
    [metaKeySelection]="true"
    (onRowSelect)="onRowSelect($event)"
    dataKey="id"
    [lazy]="true"
    [lazyLoadOnInit]="false"
    (onLazyLoad)="onLazyLoad($event)"
    sortField="oprettelsesTidspunkt"
    [sortOrder]="-1"
    [paginator]="true"
    [rows]="100"
    [totalRecords]="apiResponse.totalRowCount"
    [showJumpToPageDropdown]="true"
    letKeepScrollPosition>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="oprettelsesTidspunkt" style="width: 100px">
          Dato
          <p-sortIcon field="oprettelsesTidspunkt" />
        </th>
        <th style="width: 40px">Vis</th>
        <th pSortableColumn="dokumentType.navn">
          Skabelon
          <p-sortIcon field="dokumentType.navn" />
        </th>
        <th pSortableColumn="beskrivelse">
          Navn
          <p-sortIcon field="beskrivelse" />
        </th>
        <th pSortableColumn="stoerrelse">
          Størrelse
          <p-sortIcon field="stoerrelse" />
        </th>
        <th>CPR nr</th>
      </tr>
    </ng-template>
    <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-item>
      <tr [pSelectableRow]="item" class="cursor-pointer">
        <td class="numbers text-nowrap">
          {{ item.oprettelsesTidspunkt | date: 'dd-MM-yyyy' }}
        </td>
        <td>
          <i class="pi pi-file-pdf" (click)="visDokument(item, $event)"></i>
        </td>
        <td>
          {{ item.dokumentType?.navn }} {{ item.dokumentType?.beskrivelse }}
        </td>
        <td>{{ item.beskrivelse }}</td>
        <td>{{ item.stoerrelse }} kB</td>
        <td>{{ item.cprNummer | cprNummer }}</td>
      </tr>
    </ng-template>
  </p-table>
}
